import { createStore } from 'vuex';
import website from './modules/website';
import user from './modules/user';

export default createStore({
  modules: {
    website,
    user,
  },
});